import { Div, router, state } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import catalog from '../../services/country-occasions'
import style from './index.module.css'

// The country directory: every country the catalog carries, each opening its
// own year of holidays at /occasions/country/<slug>.
//
// The list is fetched, so it arrives after the page does. Only the marks answer
// a later settings change — rebuilding the whole list on every theme switch
// would refetch and redraw for nothing.
export const CountriesPage = () => {
    const base = SheetPage('تعطیلات و رویدادهای کشورها')

    const list = Div()
    list.addClass(style.list)
    base.append(list)

    let syncers: (() => void)[] = []
    const syncAll = () => syncers.forEach(fn => fn())

    const render = async () => {
        list.empty()
        syncers = []
        const all = await catalog.countries()

        if (!all.length) {
            const empty = Div('فهرست کشورها در دسترس نیست. برای بار اول به اینترنت نیاز است.')
            empty.addClass(style.empty)
            list.append(empty)
            return
        }

        for (const country of all) {
            const row = Div()
            row.addClass(style.row)
            row.el.onclick = () => router.goto(`/occasions/country/${country.slug}`)

            const name = Div(country.names.fa ?? country.names.en)
            name.addClass(style.name)
            row.append(name)

            // Whether it is already in the user's calendar, and whether all of
            // it is — someone who switched a few days off should be told that
            // here rather than have to open the country to find out.
            const mark = Div()
            mark.addClass(style.added)
            row.append(mark)
            syncers.push(() => {
                const sub = catalog.subscription(country.code)
                if (!sub) {
                    mark.el.textContent = ''
                    return
                }
                if (sub.regions === undefined && !sub.hidden.length) {
                    mark.el.textContent = 'همهٔ رویدادها به تقویم اضافه شده‌اند'
                    return
                }
                if (sub.regions?.length === 1 && !sub.hidden.length) {
                    const region = country.regions.find(r => r.code === sub.regions![0])
                    const name = region?.names.fa ?? region?.names.en
                    mark.el.textContent = name
                        ? `تعطیلات ${name} به تقویم اضافه شده‌اند`
                        : 'بعضی از رویدادها به تقویم اضافه شده‌اند'
                    return
                }
                mark.el.textContent = 'بعضی از رویدادها به تقویم اضافه شده‌اند'
            })

            list.append(row)
        }
        syncAll()
    }

    void render()
    state.on('settings', syncAll)
    base.on('unmounted', () => state.off('settings', syncAll))

    return base
}
